import {
  FRAME_COLORS,
  TILE_SIZES,
  TILE_SIZES_ROTATION,
} from '@mixtiles/web-backend-shared'
import StorageManager from '../../services/StorageManager'
import { MIXED_SIZES } from '../../pages/PhotoStyler/TileDesignerConsts'
import { guardIsEnum } from '../../utils/typeUtils'
import { type AiTemplateType } from 'types/ai/template-schema'

export const SELECTED_SIZE_KEY = 'SelectedSize'
export const SELECTED_COLOR_KEY = 'SelectedColor'

export function setSelectedColor(color: string | null) {
  if (color && guardIsEnum(color, FRAME_COLORS)) {
    StorageManager.set(SELECTED_COLOR_KEY, color)
  }
}

export function setSelectedSize(size: string | null) {
  if (!size) {
    return
  }

  const upperCaseSize = size.toUpperCase()
  if (size === MIXED_SIZES) {
    StorageManager.set(SELECTED_SIZE_KEY, MIXED_SIZES)
  } else if (guardIsEnum(upperCaseSize, TILE_SIZES)) {
    StorageManager.set(SELECTED_SIZE_KEY, upperCaseSize)
  }
}

export function isRotated(size1: TILE_SIZES, size2: TILE_SIZES) {
  return size1 === TILE_SIZES_ROTATION[size2]
}

export function getDefaultTileSize(): TILE_SIZES {
  return TILE_SIZES.SQUARE_8X8
}

export function getDefaultArtTileSize(): TILE_SIZES {
  return TILE_SIZES.RECTANGLE_12X16
}

export function getDefaultAIGenTileSize(
  templateType?: AiTemplateType,
  tileCount?: number
): TILE_SIZES {
  if (
    templateType === 'MULTI_INPUT_DYNAMIC_WALL_12x16' ||
    templateType === 'SINGLE_INPUT_DYNAMIC_WALL_12x16' ||
    templateType === 'FORM_INPUT_DYNAMIC_WALL'
  ) {
    return TILE_SIZES.RECTANGLE_12X16
  }

  if (
    templateType === 'MULTI_INPUT_DYNAMIC_WALL_20x27' ||
    templateType === 'SINGLE_INPUT_DYNAMIC_WALL_20x27'
  ) {
    return TILE_SIZES.RECTANGLE_20X27
  }

  if (tileCount && tileCount > 6) return TILE_SIZES.SQUARE_8X8
  if (templateType === 'WALL_SQUARE') return TILE_SIZES.SQUARE_12X12
  if (templateType === 'WALL_SQUARE_SIX') return TILE_SIZES.SQUARE_12X12
  return TILE_SIZES.RECTANGLE_20X27
}
